import { render, staticRenderFns } from "./wasteExchangeMainConfirm.vue?vue&type=template&id=67d20a4d&scoped=true"
import script from "./wasteExchangeMainConfirm.vue?vue&type=script&lang=js"
export * from "./wasteExchangeMainConfirm.vue?vue&type=script&lang=js"
import style0 from "./wasteExchangeMainConfirm.vue?vue&type=style&index=0&id=67d20a4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6d50957d97179d0c2dc3f7fe111d18c4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d20a4d",
  null
  
)

export default component.exports